export enum SciTemplate {
  Default = 'default',
  SQ = 'sq',
  SberQr = 'sber_qr',
  RosaOne = 'rosa_one',
}
